'use client';

import Image from 'next/image';

import { useTotem } from '@/app/(users)/totem-by-slug/[slug]/providers/totem-provider';
import { cn } from '@/lib/utils';

export function TotemCategorySidebar() {
  const { categories, activeCategoryId, setActiveCategoryId, searchQuery } = useTotem();

  if (searchQuery.trim()) return null;

  return (
    <aside className="flex shrink-0 bg-muted/30 transition-all duration-300 portrait:w-full portrait:h-auto portrait:flex-row portrait:border-b landscape:w-[104px] landscape:h-full landscape:flex-col landscape:border-r">
      <div className="flex w-full h-full overflow-x-auto overflow-y-hidden landscape:overflow-y-auto landscape:overflow-x-hidden [&::-webkit-scrollbar]:hidden">
        <nav className="flex gap-2 p-3 portrait:flex-row portrait:items-center landscape:flex-col landscape:items-center landscape:w-full">
          {categories.map(category => {
            const isActive = category.id === activeCategoryId;

            return (
              <button
                key={category.id}
                type="button"
                className={cn(
                  'flex flex-col items-center justify-start gap-2 rounded-2xl p-2 text-center transition-colors portrait:min-w-[5rem] landscape:w-full',
                  isActive ? 'bg-background shadow-sm' : 'bg-transparent hover:bg-muted/50'
                )}
                title={category.name}
                onClick={() => setActiveCategoryId(category.id)}
              >
                <div className="relative size-14 shrink-0 overflow-hidden rounded-xl bg-background shadow-sm">
                  {category.image_url ? (
                    <Image alt={category.name} className="object-cover" fill sizes="56px" src={category.image_url} />
                  ) : (
                    <div className="flex size-full items-center justify-center text-xs text-muted-foreground">
                      {category.name.slice(0, 1)}
                    </div>
                  )}
                </div>
                <span
                  className={cn(
                    'text-xs font-semibold leading-tight',
                    isActive ? 'text-foreground' : 'text-muted-foreground'
                  )}
                >
                  {category.name}
                </span>
              </button>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}
